<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- funcionário -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                      Médico <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="medicos"
                        @selected-data="(val) => (store.formConsulta.medico_id = val.value)"
                      />
                    </div>
                  </div>

                  <span
                    name="formConsulta.medico_id"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- paciente -->
                <div class="md:col-span-3">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
                      Informe o paciente <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="pacientes"
                        @selected-data="(val) => (store.formConsulta.paciente_id = val.value)"
                      />
                    </div>
                  </div>

                  <span
                    name="formConsulta.paciente_id"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- data de realizado -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="datetime-local"
                    name="form.realizado_em"
                    v-model="store.formConsulta.data"
                    label="Data da consulta"
                    :info="'Data da consulta'"
                    :required-field="true"
                    :activeDefault="true"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.formConsulta.data = null"
                      />
                    </template>
                  </BaseInput>

                  <span
                    name="formConsulta.data"
                    class="text-red-600 text-sm"
                  />
                </div>

              </div>
            </div>
          </div>
          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <!-- <FloatBackPage /> -->
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { dataAso } from '../store'
import { docType } from '../lookups/form';
import { 
  PhCloudArrowUp,
  PhFileArrowUp
} from '@phosphor-icons/vue';

export default({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
  },
  props: {
    descriptionTitle: String,
  },
  data () {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataAso.state,
      dataAso,
      docType,
    }
  },
  computed: {
    medicos() {
      return this.dataAso.getters.getDocs.map(item => ({
        value: item.id,
        name: item.nome
      }));
    },
    pacientes() {
      return this.dataAso.getters.getPacientes.map(item => ({
        value: item.id,
        name: item.nome
      }));
    },
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        this.selectedFileName = file.name
        this.selectedFileUrl = URL.createObjectURL(file)
        
        this.store.form.docName = this.selectedFileName
        this.store.form.doc = file
      }
    }
  }
})
</script>
